module.exports = __webpack_public_path__ + "static/media/arrowUp.bad07684.svg";